// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__On8pi","option":"styles_option__1-3O-","active":"styles_active__2QOQN"};